import { createElementBlock as r, openBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function n(t, l) {
  return o(), r("svg", c, [...l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.03 4.935a.63.63 0 0 1 .47-.213h12c.178 0 .349.077.47.213a.68.68 0 0 1 .171.501l-.743 10.794c-.088 1.279-1.115 2.27-2.351 2.27H6.953c-1.236 0-2.263-.991-2.35-2.27L3.858 5.436a.68.68 0 0 1 .17-.501m1.16 1.12.695 10.08c.04.581.506 1.032 1.068 1.032h7.094c.562 0 1.028-.45 1.068-1.032l.695-10.08z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 5.389c0-.368.288-.667.643-.667h13.714c.355 0 .643.299.643.667a.655.655 0 0 1-.643.667H3.643A.655.655 0 0 1 3 5.389",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.883 2.993A1.6 1.6 0 0 1 9.031 2.5h2.938c.43 0 .843.177 1.148.493.304.315.475.743.475 1.19v1.015a.655.655 0 0 1-.643.667H8.05a.655.655 0 0 1-.643-.667V4.183c0-.447.171-.875.475-1.19m1.148.84a.33.33 0 0 0-.239.103.36.36 0 0 0-.098.247v.349h3.612v-.35a.36.36 0 0 0-.099-.246.33.33 0 0 0-.238-.103zM9.03 8.087c.356 0 .643.299.643.667v5.08a.655.655 0 0 1-.642.666.655.655 0 0 1-.643-.667v-5.08c0-.367.288-.666.643-.666M11.97 8.087c.354 0 .642.299.642.667v5.08a.655.655 0 0 1-.643.666.655.655 0 0 1-.643-.667v-5.08c0-.367.288-.666.643-.666",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const a = { render: n };
export {
  a as default,
  n as render
};
